import { BaseInputFilter } from "domain/models/base-input-filter";
import {
  useCreateDocumentMutation,
  useDeleteDocumentMutation,
} from "presentation/hooks/use-query-document";
import { useJobTitleByFilter } from "presentation/hooks/use-query-job-title";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";

import {
  useCreatePurchaseOrderMutation,
  usePurchaseOrdersById,
  useUpdatePurchaseOrderMutation,
} from "presentation/hooks/use-query-purchase-order";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { usePurchaseOrderStore } from "presentation/stores/use-purchase-order-store";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import PurchaseOrderInfoForm from "./PurchaseOrderInfoForm";

const PurchaseOrderForm: React.FC = () => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const { id } = useParams();
  const { purchaseOrder, setPurchaseOrder, resetPurchaseOrder } =
    usePurchaseOrderStore();
  const { setPurchaseOrderStatus, setPurchaseOrderType } = useParameterStore();
  const {
    mutate: createPurchaseOrderMutation,
    error: creationError,
    isError: isCreationError,
    isSuccess: isCreationSuccess,
    data: purchaseOrderCreated,
  } = useCreatePurchaseOrderMutation();
  const {
    mutate: updatePurchaseOrderMutation,
    error: updatingError,
    isError: isUpdatingError,
    isSuccess: isUpdatingSuccess,
  } = useUpdatePurchaseOrderMutation();
  const {
    mutate: createDocumentMutation,
    error: creationDocError,
    isError: isCreationDocError,
    isSuccess: isCreationDocSuccess,
    data: documentCreated,
  } = useCreateDocumentMutation();
  const {
    mutate: deleteDocumentMutation,
    error: deletingDocError,
    isError: isDeletingDocError,
    isSuccess: isDeletingDocSuccess,
  } = useDeleteDocumentMutation();
  const { data, isError, isLoading, error } = usePurchaseOrdersById(id);

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);
  const { data: jobTitles } = useJobTitleByFilter({
    limit: 100,
  } as BaseInputFilter);

  useEffect(() => {
    setPurchaseOrderStatus(
      parameters?.data?.filter((item) => item.type === "purchaseOrderStatus")
    );

    setPurchaseOrderType(
      parameters?.data?.filter((item) => item.type === "purchaseOrderType")
    );
  }, [parameters]);

  useEffect(() => {
    if (data && data.data) {
      setPurchaseOrder(data.data);
    } else if (isError) {
      console.error("Erro ao carregar dados do colaborador:", error);
    }
  }, [data, isError, error]);

  const handleNextTab = async () => {
    if (purchaseOrder) {
      !purchaseOrder.id
        ? createPurchaseOrderMutation(purchaseOrder)
        : updatePurchaseOrderMutation(purchaseOrder);
    }
  };

  useEffect(() => {
    if (isCreationError || isUpdatingError) {
      console.log(updatingError);
      let message = [];
      message.push(
        isCreationError ? creationError.message : updatingError.message
      );

      if (
        creationError &&
        creationError.response.data.metadata.errors &&
        creationError.response.data.metadata.errors.length > 0
      ) {
        message = creationError.response.data.metadata.errors;
      } else if (
        updatingError &&
        updatingError.response.data.metadata.errors &&
        updatingError.response.data.metadata.errors.length > 0
      ) {
        message = updatingError.response.data.metadata.errors;
      }
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 1500,
        });
      });
    }
  }, [creationError, updatingError]);

  useEffect(() => {
    if (isCreationDocError || isDeletingDocError) {
      let message = isCreationError
        ? creationDocError.message
        : deletingDocError.message;

      if (
        creationDocError.response.data.metadata.errors &&
        creationDocError.response.data.metadata.errors.length > 0
      ) {
        message = creationDocError.response.data.metadata.errors;
      } else if (
        deletingDocError.response.data.metadata.errors &&
        deletingDocError.response.data.metadata.errors.length > 0
      ) {
        message = deletingDocError.response.data.metadata.errors;
      }

      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 1500,
        });
      });
    }
  }, [creationDocError, deletingDocError]);

  useEffect(() => {
    if (isCreationSuccess || isUpdatingSuccess) {
      const purchaseOrderId =
        purchaseOrder?.id || purchaseOrderCreated?.data?.id;

      if (!purchaseOrderId) {
        console.error("Erro: purchaseOrderId está undefined!");
        return;
      }

      const successMessage = isCreationSuccess
        ? "Ordem de Compra registrada com sucesso"
        : "Ordem de Compra atualizada com sucesso";

      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 1500,
      });

      setTimeout(() => {
        resetPurchaseOrder();
        navigate("/purchaseOrders");
      }, 2000);
    }
  }, [
    isCreationSuccess,
    isUpdatingSuccess,
    resetPurchaseOrder,
    navigate,
    purchaseOrderCreated,
  ]);

  return (
    <div className="card">
      <TabView>
        <TabPanel header="Ordem de Compra" leftIcon="pi pi-wallet mr-2">
          <PurchaseOrderInfoForm />
        </TabPanel>
      </TabView>
      <div className="next-button default-4-cols ">
        {" "}
        <Button
          label="Guardar"
          onClick={handleNextTab}
          className="button-size"
        />
      </div>
      <Toast ref={toast} position="bottom-right" />
    </div>
  );
};
export default PurchaseOrderForm;
